import useConfirmationAlertDialog from './use-confirmation-alert-dialog';

const useConfirmEngagementDialog = () => {
  const openConfirmationAlertDialog = useConfirmationAlertDialog();
  const message = (
    <div>
      Positive outreach has been made with the candidate where they meet the
      following minimum engagement threshold:
      <ul>
        <li>The candidate has a positive disposition on Reema </li>
        <li>
          The candidate does not express hesitation around legitimacy after
          being introduced to the Guide, beyond asking for a business card or
          being directed to the website
        </li>
        <li>The Guide has an intentional next step with the candidate</li>
        <li>
          The candidate understands the Guide will make every attempt to
          maintain monthly contact in order to continue with program enrollment
        </li>
        <li>The candidate has been informed of and completed consents</li>
      </ul>
    </div>
  );

  return () =>
    openConfirmationAlertDialog({
      title: 'Mark as engaged',
      message: message,
      cancelText: 'No',
      confirmationText: 'Yes, save and mark as engaged',
      hideIcon: true,
    });
};

export default useConfirmEngagementDialog;
